import { useEffect } from "react";
// import { useNavigate } from "react-router-dom";


export default function RedirectScreen() {
//   const navigate = useNavigate();

    useEffect(() => {
        window.open("https://192.168.1.77:4433/avp/olo?idUtente=100&idAvp=47", "_blank");
    }, []);

    return(
        <>
        </>
    )
}